LS.util.route({
	'account': {
		'$guard:eval': {
			'messages': {
				'$index': {
					':load': 'account.messages',
					':unload': 'account.messages:unload'
				}
			}
		}
	}
});